
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import CMSUser from '@/models/CMSUser';

@Component({
    name: 'CmsCommercialistTable',
})
export default class CmsCommercialistTable extends Vue {
    @Prop({ type: Object, required: false, default: () => ({}) }) readonly entityData!: any;

    private search: string = '';
    private selectedRowKeys: string[] = [];
    private isDeleting: boolean = false;

    private get columns() {
        return [
            {
                title: this.$t('Name'),
                dataIndex: 'name',
                sortDirections: ['descend', 'ascend'],
                sorter: (a: any, b: any) => a.name.localeCompare(b.name),
            },
            {
                title: this.$t('Email'),
                dataIndex: 'email',
                sortDirections: ['descend', 'ascend'],
                sorter: (a: any, b: any) => a.name.localeCompare(b.email),
            },
            {
                title: this.$t('Enabled'),
                dataIndex: 'enabled',
                align: 'center',
            },
            // {
            //     title: this.$t('Projects'),
            //     dataIndex: 'projects',
            //     align: 'center',
            // },
        ];
    }

    private get filteredList(): any[] {
        if (!this.entityData || !this.entityData.dataSource) {
            return [];
        }
        // Filter only archived users and add placeholder properties
        return this.entityData.dataSource
            .filter((user: any) => {
                return user.name.toLowerCase().includes(this.search.toLowerCase()) && user.isArchived === true;
            })
            .map((user: any) => ({
                ...user,
                enabled: user.isEnabled ? '✅' : '❌',
            }));
    }

    private get total(): number {
        return this.filteredList.length;
    }

    private get rowSelection(): any {
        return {
            selectedRowKeys: this.selectedRowKeys,
            onChange: (selectedRowKeys: string[]) => {
                this.selectedRowKeys = selectedRowKeys;
            },
        };
    }

    private async handleDelete() {
        if (this.selectedRowKeys.length === 0) {
            return;
        }

        this.isDeleting = true;

        try {
            // Delete all selected users
            const deletePromises = this.selectedRowKeys.map((userId) => CMSUser.onDelete(userId));
            await Promise.all(deletePromises);

            this.entityData.dataSource.forEach((user: any, userIndex: number) => {
                if (this.selectedRowKeys.includes(user.id)) {
                    this.$set(user, 'isEnabled', false);
                }
            });

            this.$notification.success({
                message: this.$t('Connections successfully removed') as string,
                description: '',
            });

            // Refresh the data
            await CMSUser.getAll();
        } catch (error) {
            this.$notification.error({
                message: this.$t('There was an error deleting connections') as string,
                description: '',
            });
        } finally {
            this.selectedRowKeys = [];
            this.isDeleting = false;
        }
    }
}
